import React from "react";

import { Button } from '../../../../helpers';
import "../../index.css"


const StructuredMaterialsConfirmModal = (props) => {
    const { tempMaterialItems } = props

    const handleRaisePriorityAnyway = () => {
        const lowPriorityMaterials = tempMaterialItems.filter(eachMaterial => eachMaterial.priority !== 1)
        props.submitRaisePriorityMaterials(lowPriorityMaterials)
    }

    return (
        <div className="predict-category">
            <div className="gif-container" >
                <img
                    className="gif"
                    src="https://i.giphy.com/media/v1.Y2lkPTc5MGI3NjExM3pnaG10Znc3aWVkcm9lcGt3eXFzbGxtcWY5MzdpYnpmanh6NndjeSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/5k5vZwRFZR5aZeniqb/giphy.gif"
                    alt="Jaadu AI"

                />
                <p className="jaadu-text">Hey, I'm Jaadu</p>
            </div>
            <div className="jaadu-intro">
                <p>
                    Jaadu has identified some of the materials are structured materials.
                    Please review the mandatory params before raising priority.
                </p>
            </div>
            <div className="flex justify-content-end">
                <Button
                    className="small-btn mr-2"
                    label="Back"
                    style={{backgroundColor:"gray", border:"none"}}
                    onClick={() => {
                        props.setIsMaterialSpecsConfirmModalVisible(false)
                    }}
                />
                <Button
                    className=""
                    label="Raise Priority Anyway"
                    style={{ border: 'none'}}
                    onClick={() => {
                        handleRaisePriorityAnyway(false)
                    }}
                />
            </div>
        </div>
    )
}

export default StructuredMaterialsConfirmModal;